"use strict";
/**
* RxJs + EventBus
*
*
* @langversion TypeScript 2.0
* @tiptext
*
*/
Object.defineProperty(exports, "__esModule", { value: true });
var Observable_1 = require("rxjs/Observable");
var torxemitteroperator_1 = require("./torxemitteroperator");
function toRxEmitter(a, b) {
    var eventObj = typeof a == 'object' ? a : { eventName: a, map: b };
    if (eventObj.name)
        eventObj.eventName = eventObj.name;
    if (eventObj.event)
        eventObj.eventName = eventObj.event;
    return this.lift(new torxemitteroperator_1.ToRxEmitterOperator(eventObj))
        .subscribe(function (x) { eventObj.log && console.log(x); });
}
exports.toRxEmitter = toRxEmitter;
Observable_1.Observable.prototype.toRxEmitter = toRxEmitter;
//# sourceMappingURL=torxemitter.js.map


//////////////////
// WEBPACK FOOTER
// ./~/rxemitter/torxemitter.js
// module id = 1313
// module chunks = 0